import { Suspense } from "react";
import { Route, Routes } from "react-router";

import { PageLoading } from "~/components/loading";
import { OrganizationsContainer } from "./components/organizations.container";

export function OrganizationsRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<OrganizationsContainer />} />
      </Routes>
    </Suspense>
  );
}
